import {DeviceType, ISettings, SettingsParametersSchema, LanguageCodeList, ScreenOrientation} from '@gongxigames/framework/core/types';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export type CoreSettingsParameters = {
    gameName: string;
    platform: DeviceType;
    resolution?: number;
    orientation?: ScreenOrientation;
    actionsByKeyboardDisabled?: boolean;
    disableClientErrorReporting: boolean;
    lang: LanguageCodeList;
};

export const CORE_SETTINGS_PARAMETERS_SCHEMA: SettingsParametersSchema<CoreSettingsParameters> = {
    lang: {
        defaultValue: LanguageCodeList.en,
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => {
                const lang: string = value.toLowerCase();

                if (!LanguageCodeList[lang as LanguageCodeList]) {
                    consoleLogger.warn(`${lang} language is not supported!`);

                    return LanguageCodeList.en;
                }

                return lang as LanguageCodeList;
            }
        }
    },
    gameName: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            alias: 'gamename',
            typePropertyInURL: 'string'
        }
    },
    platform: {
        readonly: true,
        defaultValue: DeviceType.DESKTOP
    },
    resolution: {
        defaultValue: undefined,
        urlParser: {
            typePropertyInURL: 'number',
            alias: 'force_resolution'
        }
    },
    orientation: {
        readonly: true,
        defaultValue: undefined,
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    actionsByKeyboardDisabled: {
        readonly: true,
        defaultValue: false
    },
    disableClientErrorReporting: {
        defaultValue: false,
        urlParser: {
            typePropertyInURL: 'boolean'
        }
    }
};

export type CoreSettings = ISettings<CoreSettingsParameters>;
